/**
 * author       : zwl
 * createTime   : 2018/7/13 上午8:57
 * description  :
 */
import api from 'util/axios'

export function createUserOrder (orderUserParam) {
  return api({
    method: 'post',
    url: '/orderUser/' + orderUserParam.appId,
    data: orderUserParam
  })
}

export function updateUserOrder (userOrderId, orderUserParam) {
  return api({
    method: 'put',
    url: '/orderUser/' + userOrderId + '/' + orderUserParam.appId,
    data: orderUserParam
  })
}

export function deleteUserOrder (userOrderId, orderUserParam) {
  return api({
    method: 'delete',
    url: '/orderUser/' + userOrderId + '/' + orderUserParam.appId,
    data: orderUserParam
  })
}
